import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
    password:Yup.string().matches().required("New Password required!"),
    confirmPassword: Yup.string().oneOf([
        Yup.ref('password'),null
    ],'Re-enter New Password and New Password must match!')
    .required("Re-enter New Password is required!")
})